/**
 * Base class for run objects. All data relative (0–1).
 */
export class RunGameObject {
  constructor(bottomCenterPosition, slot, progress, width) {
    this.bottomCenterPosition = bottomCenterPosition;
    this.slot = slot;
    this.progress = progress;
    this.width = width;
    this.collected = false;
  }
  draw(ctx, pixelX, pixelY, pixelW, pixelH) {}
  getType() { return "base"; }
}
